var _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgChromeIcon = function SvgChromeIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 39.9383 40.0029",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 15.7269,
    y1: 761.3315,
    x2: 16.6619,
    y2: 761.6705,
    gradientTransform: "matrix(27.2683, 0, 0, -39.98, 235.7934, 30832.1196)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4caf50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#4aaf50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    stopColor: "#43ad50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#38aa50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.892,
    stopColor: "#27a550"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.978,
    stopColor: "#11a050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a9e50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 20.7079,
    y1: 761.9947,
    x2: 20.7079,
    y2: 761.2747,
    gradientTransform: "matrix(20.84, 0, 0, -40, 261.32, 30847.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#ffd645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#fed43e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#fccf33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#fac922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964,
    stopColor: "#f7c10c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5bc00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 13.7817,
    y1: 756.2584,
    x2: 13.0747,
    y2: 756.8944,
    gradientTransform: "matrix(34.7, 0, 0, -24.1329, 231.44, 18645.693)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7572f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523,
    stopColor: "#f7552d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712,
    stopColor: "#f75026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#f7461b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.954,
    stopColor: "#f7390a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f73100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 29.667,
    y1: 748.203,
    x2: 30.3747,
    y2: 748.9096,
    gradientTransform: "matrix(14, 0, 0, -14, 262, 10866.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2aa4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007ad9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "icons8-chrome"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1879",
    "data-name": "Path 1879",
    d: "M693.2921,385.7133a10,10,0,1,1-10-10A10,10,0,0,1,693.2921,385.7133Z",
    transform: "translate(-663.3538 -365.7104)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1880",
    "data-name": "Path 1880",
    d: "M690.6221,390.9233l-8.16,14.77a20,20,0,0,1,.83-39.98v11a9,9,0,1,0,7.33,14.21Z",
    transform: "translate(-663.3538 -365.7104)",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1881",
    "data-name": "Path 1881",
    d: "M703.2921,385.7133a19.994,19.994,0,0,1-19.988,20h-.852l8.17-14.79a8.991,8.991,0,0,0-7.33-14.21v-11A20.028,20.028,0,0,1,703.2921,385.7133Z",
    transform: "translate(-663.3538 -365.7104)",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1882",
    "data-name": "Path 1882",
    d: "M701.1321,376.7133h-17.84a9,9,0,0,0-9,9,8.8511,8.8511,0,0,0,1.01,4.13h-.01l-8.84-14.87h-.02a19.9719,19.9719,0,0,1,34.7,1.74Z",
    transform: "translate(-663.3538 -365.7104)",
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1883",
    "data-name": "Path 1883",
    d: "M690.2921,385.7133a7,7,0,1,1-7-7A7,7,0,0,1,690.2921,385.7133Z",
    transform: "translate(-663.3538 -365.7104)",
    style: {
      fill: "url(#linear-gradient-4)"
    }
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChromeIcon);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";